import { ImageWithFallback } from '@/components/image-with-fallback';

import { AVATAR_SIZE, DEFAULT_AVATAR } from './constant';
import styles from './styles.module.scss';
import type { Component } from './types';

export const CardWithAvatar: Component = ({
  avatar, avatarSize, upperChildNode, lowerChildNode, showDivider,
}) => (
  <div className={styles.containerAvatarContent}>
    <div className={styles.containerUserInfo}>
      <div className={styles.containerAvatar}>
        <ImageWithFallback
          alt="icon image"
          className={styles.avatar}
          height={avatarSize ?? AVATAR_SIZE}
          src={avatar ?? DEFAULT_AVATAR}
          width={avatarSize ?? AVATAR_SIZE} />
      </div>
      {upperChildNode}
    </div>
    {showDivider && (
      <div>
        <hr className={styles.divider} />
      </div>
    )}
    {lowerChildNode}
  </div>
);
